<script lang="ts">
	export let cookies: string;

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html `<script type="text/javascript" charset="UTF-8" src="//cdn.cookie-script.com/s/${cookies}.js"></script>`}
